import React from 'react';
import StatsPanel from '../../components/Statistics/StatsPanel';

const Statistiques = ({ titre }) => {
  return (
    <>
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">{titre}</h1>
      </div>

      <StatsPanel compact={false} />
    </>
  );
}

export default Statistiques;